module.exports = __webpack_public_path__ + "img/banner.d2ab7757.png";